import { Injectable } from "@angular/core";
import { Http, Response, URLSearchParams, Headers } from "@angular/http";
import { Observable } from "rxjs/Observable";
import { AdalHttp } from '../../services/adal.http.service';
import "rxjs/add/operator/map";
import "rxjs/add/operator/do";
import "rxjs/add/operator/catch";

@Injectable()
export class SystemTypeRegistration {
    constructor(private http: AdalHttp) {
    }

    addSystemType(systemType: string, ownershipCodeGenerationType: string, createPermissionsOnlyInCallerIdentityProvider: boolean, projectId: string): Observable<any> {
        var headers = new Headers();
        headers.append("projectId", projectId);
        headers.append('Content-Type', 'application/json');
        var requestBody = {
            'SystemType': systemType,
            'OwnershipCodeGenerationType': ownershipCodeGenerationType,
            'CreatePermissionsOnlyInCallerIdentityProvider': createPermissionsOnlyInCallerIdentityProvider
        };
        let productUrl: string = window.location.protocol + "//" + window.location.host + "/api/systemtypes";
        return this.http.post(productUrl, JSON.stringify(requestBody), {
            headers: headers
        })
            .catch((error: any) => {
                return Observable.throw(error);
            });
    }

    retrieveSystemType():Observable<any> {
        var headers = new Headers();
        headers.append('Content-Type', 'application/json');
        let productUrl: string = window.location.protocol + "//" + window.location.host + "/api/systemtypes";
        return this.http.get(productUrl)
            .catch((error: any) => {
                return Observable.throw(error || 'server error');
            });

    }
}


/** WEBPACK FOOTER **
 ** ./app/main/systemTypeManagement/system-type-registration.service.ts
 **/